import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import Auth from "./page/Auth";
import DashboardPage from "./page/DashboardPage";
import VasPage from "./page/VasPage";
import PastReports from "./page/PastReports";
import DashboardLayout from "./layouts/DashboardLayout";
import VasLayout from "./layouts/VasLayout";

const App = () => {
  const routes = createBrowserRouter([
    { path: "/", element: <Navigate to="/login" replace /> },
    { path: "/login", element: <Auth /> },
    {
      path: "/vas",
      element: <VasLayout />,
      children: [
        {
          index: true,
          element: <VasPage />,
        },
      ],
    },
    {
      path: "dashboard",
      element: <DashboardLayout />,
      children: [
        { index: true, element: <DashboardPage /> },
        { path: "past-reports", element: <PastReports /> },
      ],
    },
  ]);
  return <RouterProvider router={routes} />;
};

export default App;
